.RoundProgressBar {
    width: 100%;
    height: auto;
    position: relative;

    .progressSvg {
        transform: rotate(-90deg); // Start from top instead of right
        width: 100%;
        height: auto;
    }

    .backgroundCircle {
        stroke: #595959;
    }

    .progressCircle {
        stroke: #ffffff;
        transition: stroke-dashoffset 1s ease-in-out;
    }

    .iconContainer {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        fill: #ffffff;

        .icon {
            width: 30px;
            height: 30px;
        }
    }
}